// Shared document label/citation formatting for the map-query dataset. TYPE_LABELS
// stay per-file since the hover popup keys on tile `type` and the card on STI type.

export const humanize = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Builds the "Vol X Pg Y · <instrument>" citation shown in the card header and the
// map hover popup. `citation` is the Vol/Pg segment; `citationFull` appends the
// instrument number.
export const buildCitation = (
  volume?: unknown,
  page?: unknown,
  instrumentNumber?: unknown
): { citation: string; citationFull: string } => {
  const citation = [
    volume ? `Vol ${String(volume)}` : '',
    page ? `Pg ${String(page)}` : '',
  ]
    .filter(Boolean)
    .join(' ');
  const citationFull = [
    citation,
    instrumentNumber ? String(instrumentNumber) : '',
  ]
    .filter(Boolean)
    .join(' · ');
  return { citation, citationFull };
};
